import React from 'react'
import Chip from '@mui/material/Chip'
import { GAP_SEVERITY } from '../severity'

const GapSeverityChip = ({ severity, ...props }) => {
  const config = GAP_SEVERITY[severity] || { label: severity, color: 'default' }
  return (
    <Chip
      label={config.label}
      color={config.color}
      size="small"
      sx={{ borderRadius: 1, fontWeight: 700 }}
      {...props}
    />
  )
}

export default GapSeverityChip
